import { render, staticRenderFns } from "./OrderListAddNew.vue?vue&type=template&id=d70e10c2&"
import script from "./OrderListAddNew.vue?vue&type=script&lang=js&"
export * from "./OrderListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./OrderListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports